var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Trans } from 'react-i18next';
import i18n from '../../../../strings/i18n/i18n';
import styled from 'styled-components';
import { spacing } from 'syf-component-library/defaultTheme';
import InlineButton from '../../../../ui/atoms/OnlineChatLink';
import { Body } from 'syf-component-library/ui/typography';
import query from 'syf-component-library/const/mediaQueries';
import { Analytics } from '../../../../helpers/analyticsMiddleware';
import { shallowEqual, useSelector } from 'react-redux';
var Paragraph = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: ", "px;\n"], ["\n  margin-top: ", "px;\n"])), spacing.small);
var CaseDescriptionText = styled(Body)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: ", "px;\n  @media ", " {\n    max-width: 350px;\n  }\n"], ["\n  margin-top: ", "px;\n  @media ", " {\n    max-width: 350px;\n  }\n"])), spacing.small, query.lessThanMedium);
var RedisputeDescription = function (_a) {
    var handleLaunchChat = _a.handleLaunchChat, handleRedispute = _a.handleRedispute;
    var isRedispute = useSelector(function (state) { return state; }, shallowEqual).featureFlags.redispute;
    if (isRedispute) {
        return (_jsx(CaseDescriptionText, __assign({ "data-cy": "redispute-verbiage" }, { children: _jsx(Trans, { i18n: i18n, i18nKey: "transactionDisputeStatusDescription.ifYouDisagree", components: [
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    _jsx(InlineButton, { "data-analytics": "clicktrackingevent", "data-object": "button", "data-type": "body", "data-reason": Analytics.RedisputeTransaction, onClick: handleRedispute }),
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    _jsx(InlineButton, { "data-analytics": "clicktrackingevent", "data-cy": "online-chat-link", "data-object": "button", "data-type": "online chat", onClick: handleLaunchChat }, "online chat")
                ] }) })));
    }
    return (_jsx(Paragraph, { children: _jsx(Trans, { i18n: i18n, i18nKey: "transactionDisputeStatusDescription.ifYouDisagreeNotRedispute", components: [
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                _jsx(InlineButton, { "data-analytics": "clicktrackingevent", "data-cy": "online-chat-link", "data-object": "button", "data-type": "online chat", onClick: handleLaunchChat }, "online chat")
            ] }) }));
};
export default RedisputeDescription;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map